/* Casca da área administrativa (dono da plataforma).
 *
 * É a área separada do §06 do plano (review/17-PLANO-PAINEIS.html), com o design
 * system Nebula (dark-first) confinado a `.nebula`. Hoje só a tela Empresas (A1)
 * tem conteúdo; as outras abas são o próximo passo. O `.nebula` embrulha tudo
 * para os tokens do admin não vazarem para o painel do cliente. */

import React, { useState } from 'react';

import './nebula.css';
import Acoes from './Acoes';
import Auditoria from './Auditoria';
import Capacidades from './Capacidades';
import Empresas from './Empresas';
import Integracoes from './Integracoes';
import Numeros from './Numeros';
import Relatorios from './Relatorios';
import Saude from './Saude';
import Servidores from './Servidores';
import { Button, Icon } from './ui';
import Usuarios from './Usuarios';

const NAV = [
  { id: 'empresas', rotulo: 'Empresas' },
  { id: 'usuarios', rotulo: 'Usuários' },
  { id: 'servidores', rotulo: 'Servidores' },
  { id: 'numeros', rotulo: 'Números' },
  { id: 'capacidades', rotulo: 'Capacidades' },
  { id: 'integracoes', rotulo: 'Integrações' },
  { id: 'acoes', rotulo: 'Ações' },
  { id: 'saude', rotulo: 'Saúde' },
  { id: 'relatorios', rotulo: 'Relatórios' },
  { id: 'auditoria', rotulo: 'Auditoria' },
];

function iniciais(nome) {
  if (!nome) return 'A';
  const partes = nome.trim().split(/\s+/);
  return ((partes[0]?.[0] || '') + (partes.length > 1 ? partes[partes.length - 1][0] : '')).toUpperCase();
}

export default function PainelAdmin({ usuario, aoSair }) {
  const [aba, definirAba] = useState('empresas');

  return (
    <div className="nebula" style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden', background: 'var(--canvas)', backgroundImage: 'var(--canvas-glow)' }}>
      <header style={{ display: 'flex', alignItems: 'center', gap: 24, height: 60, flex: '0 0 auto', padding: '0 24px', background: 'var(--surface-sidebar)', borderBottom: '1px solid var(--border-subtle)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, borderRadius: 'var(--radius-md)', background: 'var(--accent)', color: '#fff', font: 'var(--type-title)', fontWeight: 'var(--fw-extrabold)' }}>S</span>
          <span style={{ font: 'var(--type-h3)', letterSpacing: 'var(--ls-tight)' }}>Sofia</span>
          <span style={{ padding: '2px 8px', borderRadius: 'var(--radius-pill)', background: 'var(--accent-soft)', color: 'var(--text-brand)', font: 'var(--type-caption)', fontWeight: 'var(--fw-semibold)', letterSpacing: 'var(--ls-wide)' }}>ADMIN</span>
        </div>

        <nav style={{ display: 'flex', gap: 4, marginLeft: 8 }}>
          {NAV.map((n) => {
            const ativa = aba === n.id;
            return (
              <button
                key={n.id}
                type="button"
                onClick={() => definirAba(n.id)}
                aria-current={ativa ? 'page' : undefined}
                style={{
                  padding: '8px 12px',
                  border: 0,
                  cursor: 'pointer',
                  borderRadius: 'var(--radius-control)',
                  background: ativa ? 'var(--accent)' : 'transparent',
                  color: ativa ? 'var(--accent-on)' : 'var(--text-secondary)',
                  font: 'var(--type-body-strong)',
                  fontSize: 'var(--fs-body-sm)',
                  fontWeight: 'var(--fw-semibold)',
                }}
              >
                {n.rotulo}
              </button>
            );
          })}
        </nav>

        <div style={{ flex: 1 }} />

        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, height: 34, padding: '0 12px', borderRadius: 'var(--radius-pill)', background: 'var(--surface-sunken)', border: '1px solid var(--border-subtle)', color: 'var(--text-secondary)', font: 'var(--type-label)' }}>
          <Icon name="shield-check" size={14} />
          Plataforma
        </span>

        <span title={usuario?.nome} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, borderRadius: '50%', background: 'var(--violet-700)', color: '#fff', font: 'var(--type-label)', fontWeight: 'var(--fw-bold)' }}>
          {iniciais(usuario?.nome)}
        </span>

        {aoSair && (
          <Button variant="ghost" icon="log-out" onClick={aoSair} style={{ height: 34, padding: '0 12px', fontSize: 'var(--fs-body-sm)' }}>Sair</Button>
        )}
      </header>

      <main style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {aba === 'empresas' && <Empresas />}
        {aba === 'usuarios' && <Usuarios />}
        {aba === 'servidores' && <Servidores />}
        {aba === 'numeros' && <Numeros />}
        {aba === 'capacidades' && <Capacidades />}
        {aba === 'integracoes' && <Integracoes />}
        {aba === 'acoes' && <Acoes />}
        {aba === 'saude' && <Saude />}
        {aba === 'relatorios' && <Relatorios />}
        {aba === 'auditoria' && <Auditoria />}
      </main>
    </div>
  );
}
